import "./src/shared/styles/global.css";
import { CommonLayout } from "./src/layout";
import {
  ShouldUpdateScrollArgs,
  WrapPageElementBrowserArgs,
  RouteUpdateArgs,
} from "gatsby";
import { LoadingManager } from "./src/providers/loading-manager";
import { curtainIsClosed } from "./src/shared/components/transition-curtain/utils";
import { getPageType } from "./src/shared/utils/getPageType";
import { AssetsLoader } from "./src/shared/assets/assets-loader";
import { smoothScroller } from "./src/providers/smooth-scroller";

window.history.scrollRestoration = "manual";

// TODO: Remove me when debugging is done
// window.SlidesManager = SlidesManager;

// Main page initial loading routine
if (
  !LoadingManager.mainPageResourcesLoaded &&
  window.location.pathname === "/"
) {
  window.LoadingManager = LoadingManager;

  const onLoaderComplete = async (
    promiseToWait?: Promise<OnLoaderCompleteResolver>,
  ) => {
    const tearDownRoutine = await promiseToWait;
    tearDownRoutine?.();
  };

  if (window.__loaderRoutine) {
    LoadingManager.init(
      [window.__loaderRoutine, AssetsLoader.loadAllVideoAssets()],
      () => {
        onLoaderComplete(window.__loaderRoutine);
        window.__loaderRoutine = undefined;
      },
    );
  }
  // if this script is loaded before the loader.js (dev mode)
  else {
    const { promise, resolve } =
      Promise.withResolvers<OnLoaderCompleteResolver>();
    window.__loaderRoutine = Promise.resolve(resolve);

    LoadingManager.init([promise, AssetsLoader.loadAllVideoAssets()], () =>
      onLoaderComplete(promise),
    );
  }
}

window.onload = () => {
  console.debug("WINDOW ONLOAD!");
};

export const onInitialClientRender = () => {
  console.debug("CLIENT INITIAL RENDER!");
};

export const wrapPageElement = ({
  element,
  props,
}: WrapPageElementBrowserArgs) => {
  return <CommonLayout props={props}>{element}</CommonLayout>;
};

export const shouldUpdateScroll = ({
  routerProps: { location },
}: ShouldUpdateScrollArgs) => {
  // default value is `true`
  // prevent a page from scrolling to top on some inter page navigation
  return !!location.hash;
};

export const onRouteUpdate = async ({
  location,
  prevLocation,
}: RouteUpdateArgs) => {
  const pageType = getPageType(location?.pathname);
  const prevPageType = prevLocation?.pathname
    ? getPageType(prevLocation.pathname)
    : undefined;

  const isSamePage = location.pathname === prevLocation?.pathname;
  const betweenInternal =
    pageType === "internal" && prevPageType === "internal";
  const toModalPage = pageType === "modal";
  const fromModalPage = prevPageType === "modal" && pageType == "internal";

  if (isSamePage) {
    // don't prevent anchor scrolling within the same page
    return;
  }

  if (betweenInternal) {
    smoothScroller.scrollToTop({ immediate: true });
    return;
  }

  if (toModalPage) {
    await curtainIsClosed();
    smoothScroller.scrollToTop({ immediate: true });
    return;
  }

  if (fromModalPage) {
    await curtainIsClosed();
    if (location.hash === "#footer") {
      window.scrollTo(0, document.body.scrollHeight);
    } else {
      smoothScroller.scrollToTop({ immediate: true });
    }
    return;
  }
};
